<template>
    <div id="organizationMapBox">
        <div id="organizationMap"></div>
        <el-button @click="reDraw">重绘区域范围</el-button>
    </div>
</template>

<script>
import AMap from "AMap" // 引入高德地图
import { post } from "@/api/requrestHttp"
function noop() {}
export default {
    name: "organizationMap",
    props: {
        orgId: {
            default: null,
        },
        onSuccess: {
            type: Function,
            default: noop,
        },
        val: {
            default: "",
        },
        mapCenter: {
            default: [],
        },
    },
    components: {},
    data() {
        return {}
    },
    methods: {
        reDraw() {
            let that = this
            let s = []
            that.onSuccess(s.join())
            if (this.polygon) {
                this.polygon.setMap(null)
            }
            this.mouseTool.close(true)
            this.mouseTool.polygon()
            var polygonArr = []
            var map = new AMap.Map("organizationMap", {
                mapStyle: "amap://styles/blue",
                //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
                zoom: 15,
                zooms: [3, 20],
                expandZoomRange: true,
                defaultCursor: "default",
                center: that.mapCenter, //初始化地图中心点
            })
            this.map = map
            var mouseTool = new AMap.MouseTool(map)
            this.mouseTool = mouseTool
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                var overlays = []
                if (polygonArr == true) {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    var isRingInRing = AMap.GeometryUtil.isRingInRing(
                        polygonArr2,
                        polygonArr
                    )
                    var doesRingRingIntersect =
                        AMap.GeometryUtil.doesRingRingIntersect(
                            polygonArr2,
                            polygonArr
                        )

                    if (!isRingInRing || doesRingRingIntersect) {
                        that.$message({
                            message: "请画出正确的网格地图",
                            type: "error",
                        })
                        mouseTool.close(true)
                        mouseTool.polygon({
                            fillOpacity: 0.3,
                            fillColor: "#2191E6",
                            strokeColor: "#007CDB",
                            //同Polygon的Option设置
                        })
                    } else {
                        let s = []
                        polygonArr2.forEach((e) => {
                            s.push(`${e[0]}:${e[1]}`)
                        })
                        that.onSuccess(s.join())
                        // that.$emit("input", s.join());
                        // console.log(s.join());
                    }
                } else {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    let s = []
                    polygonArr2.forEach((e) => {
                        s.push(`${e[0]}:${e[1]}`)
                    })
                    console.log(polygonArr2)
                    that.onSuccess(s.join())
                }
            })
            this.mouseTool.polygon({
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
                //同Polygon的Option设置
            })
        },
        mapInit(id) {
            let that = this
            var map = new AMap.Map(id, {
                mapStyle: "amap://styles/blue",
                //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
                zoom: 15,
                zooms: [3, 20],
                expandZoomRange: true,
                defaultCursor: "default",
                center: that.mapCenter, //初始化地图中心点
            })
            this.map = map
            var polygonArr = []
            if (this.orgId != 0) {
                post("/rbac/admin/org/info/findOrgById", {
                    id: this.orgId,
                }).then((res) => {
                    if (res.content) {
                        if (res.content.pointPosition) {
                            res.content.pointPosition
                                .split(",")
                                .forEach((e) => {
                                    polygonArr.push(e.split(":"))
                                })
                        }
                    }

                    var polygon = new AMap.Polygon({
                        map: map,
                        path: polygonArr, //设置多边形边界路径
                        // strokeColor: res.content ? res.content.gridColour : "", //线颜色
                        strokeColor: "#007CDB",
                        strokeOpacity: 0.2, //线透明度
                        strokeWeight: 2, //线宽
                        //   fillColor: res.content ? res.content.gridColour : "", //填充色
                        fillColor: "#2191E6",
                        fillOpacity: 0.3, //填充透明度
                        extData: {
                            name: res.content ? res.content.orgName : "",
                        },
                    })
                    this.polygon = polygon
                })
            }

            if (this.val) {
                let arrT = []
                this.val.split(",").forEach((e) => {
                    arrT.push(e.split(":"))
                })
                var polygonT = new AMap.Polygon({
                    map: map,
                    path: arrT, //设置多边形边界路径
                    strokeColor: "#007CDB", //线颜色
                    //  strokeOpacity: 0.2, //线透明度
                    fillColor: "#2191E6", //填充色
                    fillOpacity: 0.3, //填充透明度
                })
            }

            var mouseTool = new AMap.MouseTool(map)
            this.mouseTool = mouseTool
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                var overlays = []
                if (polygonArr == true) {
                    var polygonArr2 = []
                    //e.obj.getPath()替换之前的 e.obj.Ce.path
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    var isRingInRing = AMap.GeometryUtil.isRingInRing(
                        polygonArr2,
                        polygonArr
                    )
                    var doesRingRingIntersect =
                        AMap.GeometryUtil.doesRingRingIntersect(
                            polygonArr2,
                            polygonArr
                        )

                    if (!isRingInRing || doesRingRingIntersect) {
                        that.$message({
                            message: "请画出正确的网格地图",
                            type: "error",
                        })
                        mouseTool.close(true)
                        mouseTool.polygon({
                            fillOpacity: 0.3,
                            fillColor: "#2191E6",
                            strokeColor: "#007CDB",
                            //同Polygon的Option设置
                        })
                        console.log("11111")
                    } else {
                        let s = []
                        polygonArr2.forEach((e) => {
                            s.push(`${e[0]}:${e[1]}`)
                        })
                        that.onSuccess(s.join())
                        // that.$emit("input", s.join());
                        // console.log(s.join());
                        console.log("2222")
                    }
                    console.log("ififiif")
                } else {
                    //获取路径 e.obj.getPath()
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    let s = []
                    polygonArr2.forEach((e) => {
                        s.push(`${e[0]}:${e[1]}`)
                    })
                    console.log(polygonArr2)
                    that.onSuccess(s.join())
                }
            })
            this.mouseTool.polygon({
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
                //同Polygon的Option设置
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.mapInit("organizationMap")
        })
        // console.log()
    },
    created() {},
    watch: {
        mapCenter(ols, nes) {
            this.$nextTick(() => {
                this.mapInit("organizationMap")
            })
        },
    },
}
</script>
<style lang="less" >
#organizationMap {
    width: 100%;
    height: 470px;
}
</style>